<template>
  <oscillography-analysis-alarm-persistence
    :alarm-mode="alarmMode"
    :alarm-mode-options="alarmModeOptions"
    :loading="loading"
    :phase="phase"
    :rows="rows"
    @update:alarmMode="$emit('update:alarmMode', $event)"
    @open-history="$emit('open-history')"
  />
</template>

<script>
import OscillographyAnalysisAlarmPersistence from './OscillographyAnalysisAlarmPersistence';

export default {
  name: 'OscillographyAnalysisAlarmsTab',
  components: {
    OscillographyAnalysisAlarmPersistence,
  },
  props: {
    alarmMode: {
      type: String,
      default: 'breaker',
    },
    alarmModeOptions: {
      type: Array,
      default: () => [],
    },
    phase: {
      type: String,
      default: '',
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
